Bonkers = {
  actionCableUrl () {
    var protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
    var wsPath = document.head.querySelector('meta[name="action-cable-url"]').getAttribute('content');
    return `${protocol}://${window.location.host}${wsPath}`;
  },

  addthis: {
    config: {
      pubid: 'ra-568275e9f9cf2825',
      data_use_cookies_ondomain: !1,
      data_use_cookies: !1
    },
    share: { passthrough: { twitter: { via: 'bonkers_ie' } } }
  },

  baseUrl () {
    return `${window.location.protocol}//${window.location.host}`;
  },

  animationTime: 300,

  colours: {
    green: '#70bf4a',
    grey: '#989898',
    marine: '#334d5c',
    teal: '#419dab'
  },

  /* eslint-disable no-useless-escape */
  emailRegex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  /* eslint-enable no-useless-escape */

  gaId: 'UA-12505558-1',

  gtmId: 'GTM-TQVZGP',

  isProduction: function () {
    return window.location.href.startsWith('https://www.bonkers.ie');
  },

  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],

  tinymce: {
    default: {
      browser_spellcheck: true,
      branding: false,
      convert_urls: false,
      height: [200],
      menubar: false,
      plugins: ['advlist', 'autolink', 'code', 'contextmenu', 'hr', 'image', 'link', 'lists', 'paste', 'spellchecker', 'textpattern', 'visualblocks'],
      selector: 'textarea.tinymce',
      skin: false,
      toolbar: ['undo redo | cut copy paste pastetext | code', 'styleselect | bold italic underline | numlist bullist | alignleft aligncenter alignright alignjustify alignnone', 'hr image link'],
      default_link_target: '_blank'
    },
    article: {
      schema: 'html5',
      autosave_interval: '10s',
      autosave_retention: '120m',
      height: [600],
      menubar: {
        format: {
          blocks: [{ block: 'h2', title: 'Heading 2' }, {
            block: 'h3',
            title: 'Heading 3'
          }, { block: 'h4', title: 'Heading 4' }, {
            block: 'h5',
            title: 'Heading 5'
          }, { block: 'h6', title: 'Heading 6' }, {
            block: 'p',
            title: 'Paragraph'
          }, { inline: 'small', title: 'small' }, { inline: 'pre', title: 'Preformated' }],
          style_formats: [{ block: 'h2', title: 'Heading 2' }, {
            block: 'h3',
            title: 'Heading 3'
          }, { block: 'h4', title: 'Heading 4' }, {
            block: 'h5',
            title: 'Heading 5'
          }, { block: 'h6', title: 'Heading 6' }, {
            block: 'p',
            title: 'Paragraph'
          }, { inline: 'small', title: 'small' }, { inline: 'pre', title: 'Preformated' }]
        }
      },
      plugins: ['advlist', 'autolink', 'autosave', 'code', 'colorpicker', 'contextmenu', 'hr', 'image', 'link', 'lists', 'media', 'paste', 'spellchecker', 'table', 'textcolor', 'textpattern', 'visualblocks'],
      toolbar: ['undo redo | cut copy | code', 'styleselect | bold italic underline strikethrough | blockquote | numlist bullist | alignleft aligncenter alignright alignjustify alignnone | forecolor backcolor | hr image link media'],
      valid_elements: ['a[href|target]', 'b', 'blockquote[class|data-lang]', 'br', 'caption', 'center', 'div[class]', 'em', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', 'iframe[src|loading=lazy|frameborder=0|allowfullscreen|height|width|onload|id|style]', 'img[alt|border|src|style|title|height|width]', 'li', 'ol', 'p', 'script[async|charset|src]', 'small', 'source[src|type]', 'span[class|style]', 'strong', 'table', 'tbody', 'td[colspan]', 'thead', 'th[*]', 'tr', 'u', 'ul', 'video[width|controls]'],
      extended_valid_elements: 'script[async|charset|language|type|src]',
      paste_preprocess: function (plugin, args) {
        args.content = args.content.replace(/<a\s+href="([^"]+)/gi, function (matched, group) {
          const url = new URL(group);
          if (url.hostname.includes('bonkers.ie')) return matched;
          return `<a target="_blank" href=${group}`;
        });
      }
    }
  },

  toCurrency: function (val) {
    return val.toLocaleString('en-IE', { style: 'currency', currency: 'EUR' }).replace(/\.00$/, '');
  },

  toTimeStamp: function (seconds) {
    seconds = parseInt(seconds);
    return '' + Math.floor(seconds / 60) + ':' + (seconds % 60).toString().padStart(2, '0');
  },

  transitionEvents: 'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd',

  widths: {
    phone: 500,
    tablet: 768,
    intermediate: 993,
    desktop: 1024,
    max: 1200
  }
};
